var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnsubscribed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.332,
    height: 50.488,
    viewBox: "0 0 114.332 50.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918",
    transform: "translate(-693.748 -229.193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_885",
    "data-name": "Group 885",
    transform: "translate(0 -36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "paper-plane-o",
    d: "M58,.92a1.48,1.48,0,0,1,.888,1.643L50.467,41.989a1.7,1.7,0,0,1-1.053,1.155,2.47,2.47,0,0,1-1.019.205,2.757,2.757,0,0,1-.79-.129L30.28,37.7l-9.8,8.393a2.207,2.207,0,0,1-1.546.538,2.346,2.346,0,0,1-.756-.1,1.972,1.972,0,0,1-.986-.6,1.41,1.41,0,0,1-.361-.936V33.39L1.317,28.437A1.6,1.6,0,0,1,0,27.024a1.459,1.459,0,0,1,1.053-1.514L55.76.868A2.355,2.355,0,0,1,58,.919ZM46.752,39.4,54.018,5.438,6.874,26.665l11.047,3.517,28.372-16.4L30.578,34.237Z",
    transform: "translate(720.384 269.046)",
    fill: "#2469f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloud",
    d: "M13.317,12.583A4.532,4.532,0,0,0,9.032,9.1a4.34,4.34,0,0,0-3.539,1.9,3.186,3.186,0,0,0-.711-.081,3.572,3.572,0,0,0-3.405,3.71,3.941,3.941,0,0,0,.57,2.055.464.464,0,0,0,.393.229H15.105a.461.461,0,0,0,.379-.207,2.724,2.724,0,0,0,.474-1.542,2.467,2.467,0,0,0-2.643-2.574Z",
    transform: "translate(780.651 291.098)",
    fill: "#2469f5",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "cloud-2",
    "data-name": "cloud",
    d: "M14.187,12.837A4.862,4.862,0,0,0,9.59,9.1a4.657,4.657,0,0,0-3.8,2.036,3.418,3.418,0,0,0-.762-.087,3.832,3.832,0,0,0-3.653,3.981,4.229,4.229,0,0,0,.612,2.205.5.5,0,0,0,.422.246h13.7a.5.5,0,0,0,.407-.223,2.922,2.922,0,0,0,.509-1.655,2.647,2.647,0,0,0-2.835-2.762Z",
    transform: "translate(716.271 256.097)",
    fill: "#2469f5",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "cloud-fill",
    transform: "translate(693.748 294.601)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M6.581,6.135A9.426,9.426,0,0,1,11.95,4.5c4.018,0,7.354,2.437,7.716,5.58,2.379.274,4.234,1.9,4.234,3.892,0,2.189-2.237,3.932-4.949,3.932H5.648C2.551,17.9,0,15.913,0,13.417,0,11.269,1.891,9.49,4.395,9.039a5.081,5.081,0,0,1,2.187-2.9Z",
    transform: "translate(0 -4.5)",
    fill: "#2469f5",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "cloud-fill-2",
    "data-name": "cloud-fill",
    transform: "translate(784.18 273.573)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92-2",
    "data-name": "Path 92",
    d: "M6.581,6.135A9.426,9.426,0,0,1,11.95,4.5c4.018,0,7.354,2.437,7.716,5.58,2.379.274,4.234,1.9,4.234,3.892,0,2.189-2.237,3.932-4.949,3.932H5.648C2.551,17.9,0,15.913,0,13.417,0,11.269,1.891,9.49,4.395,9.039a5.081,5.081,0,0,1,2.187-2.9Z",
    transform: "translate(0 -4.5)",
    fill: "#2469f5",
    fillRule: "evenodd"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscribed);
export default __webpack_public_path__ + "static/media/unsubscribed.50dabd74aa8ebb364cf06c9ffb4d8f30.svg";
export { ForwardRef as ReactComponent };